import { createContext, useContext, useEffect, useState } from "react";
import { newID } from "../common/util";

const UnitCompositionContext = createContext();
export function UnitComposition(props) {
    const { unit, onChange, disableEditModels, disableEditUpgrades } = props;
    const [edit, setEdit] = useState(unit.composition)

    useEffect(() => {
        onChange(edit)
    }, [edit])

    if (!unit.composition) {
        return <></>
    }

    return <UnitCompositionContext.Provider
        value={{
            unit,
            edit,
            setEdit,
            disableEditModels,
            disableEditUpgrades,
        }}
        {...props}
    />
}

export function useUnitComposition(model, element) {
    const { unit, edit, setEdit, disableEditModels, disableEditUpgrades } = useContext(UnitCompositionContext)

    const parent = model || unit;
    const upgrades = model ? edit.models.filter(m => m.id === model.id)[0].upgrades : edit.upgrades;

    function addUpgrade(name) {
        if (model) {
            const copy = { ...model }
            copy.upgrades = [...copy.upgrades, { id: name, name: name }]
            setEdit({
                ...edit, models: edit.models.map(m => {
                    if (m.id === copy.id) {
                        return copy;
                    }
                    return m;
                })
            })
        } else {
            setEdit({ ...edit, upgrades: [...edit.upgrades, { id: newID(), name: name }] })
        }
    }
    function addModel(name) {
        setEdit({ ...edit, models: [...edit.models, { id: newID(), name: name, upgrades: [], count: 1 }] })
    }
    function remove() {
        if (model) {
            const copy = { ...model }
            copy.upgrades = model.upgrades.filter(e => e.id !== element.id)
            setEdit({
                ...edit, models: edit.models.map(m => {
                    if (m.id === copy.id) {
                        return copy;
                    }
                    return m;
                })
            })
        } else {
            setEdit({ ...edit, upgrades: edit.upgrades.filter(e => e.id !== element.id), models: edit.models ? edit.models.filter(e => e.id !== element.id) : null })
        }
    }
    function reduceCount() {
        const copy = { ...element }
        copy.count -= 1;
        if (copy.count == 0) {
            setEdit({
                ...edit, models: edit.models.filter(m => m.id !== copy.id)
            })
        } else {
            setEdit({
                ...edit, models: edit.models.map(m => {
                    if (m.id === copy.id) {
                        return copy;
                    }
                    return m;
                })
            })
        }
    }
    function increaseCount() {
        const copy = { ...element }
        copy.count += 1;
        setEdit({
            ...edit, models: edit.models.map(m => {
                if (m.id === copy.id) {
                    return copy;
                }
                return m;
            })
        })
    }

    return {
        upgrades,
        parent,
        models: edit.models,

        addUpgrade,
        addModel,
        remove,
        reduceCount,
        increaseCount,

        disableEditModels,
        disableEditUpgrades,
    }
}